module.exports = __webpack_public_path__ + "media/images/ces-editors-choice-75566de2f8537eeaaf7d286322133ba5.png";